import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import { SURVEY, Q_ADDITIONAL_COMMENTS, PATH_REDIRECT_USER } from '../../../constants';
import GeneratePdfDocument from "./generatePdfDocument";
import { StyleSheet } from '@react-pdf/renderer';

function ScrollToTop(props) {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scroll({
          top: 0, 
          left: 0, 
          behavior: 'smooth'
        });
    }, [pathname]);
    return props.children
  }

const DownloadReportCTA = ({ data, page }) => {

    const { object } = data || {}; //JSON config of the component
    const acceptedTCs = useSelector((state) => state.acceptedTCs);
    const configuration = useSelector((state) => state.configuration);
    const history = useHistory();
    const [resultsState, setResultsState] = useState([]);
    const [additionalCommentsState, setAdditionalCommentsState] = useState('');
  
    const redirectIfNonAcceptedTCs = useCallback(() => {
        if(acceptedTCs === false){
            history.push(PATH_REDIRECT_USER);
        }
    }, [acceptedTCs, history]);
    
    const { survey } = configuration;
    const { surveyResultsPage } = configuration || {};

    const { content } = surveyResultsPage || {};
    const { pdfMeta } = content || {};

    useEffect(() => {
        redirectIfNonAcceptedTCs();

        let isMounted = true; // note this flag denote mount status
            if (isMounted) {
                if(survey) {
                const cSurvey = survey.content.components.find(x=> x.id === SURVEY);
                const cAdditionalComments = survey.content.components.find(x=> x.id === Q_ADDITIONAL_COMMENTS);
                // const results = cSurvey.object.results
                const results = cSurvey.object.sections;
                setResultsState(results);
                setAdditionalCommentsState(cAdditionalComments);
            }
        }
        return () => { isMounted = false; };
    }, [configuration, survey, redirectIfNonAcceptedTCs]);

    // Render this component only if the survey data is available
    if(!survey) return null;

    var styled = StyleSheet.create({
        hidden: {
            display:'none'
        },
        result: {
            textAlign: 'left',
            color: 'white',
            border: '2px solid white',
            padding: '10px'
        },
        section: {
            color: 'red'
        },
        question: {
            fontWeight: 'bold',
            textTransform: 'uppercase'
        },
        data: {
            color: '#8ef6fc'
        },
        message: {
            color:'#fafc8e'
        }
      });

    return (
        <ScrollToTop>
            <Fragment>
                <div className='cta-div text-center fixed bottom-0 left-0 right-0 flex justify-center z-50 p-4 mb-0 md:relative md:bottom-auto md:left-auto md:right-auto md:z-auto md:p-0 md:mb-4'>

                    <GeneratePdfDocument pdfMeta={pdfMeta} resultsState={resultsState} additionalCommentsState={additionalCommentsState} >
                        {object.text}
                    </GeneratePdfDocument>

                    <div style={styled.hidden}>

                    {/* Below code is for future - Tier based messages. */}
                    {(resultsState || []).map((section, sectionIndex) => {
                        return (
                            <div key={sectionIndex}>
                            <div style={styled.result}><strong>{section.name}</strong></div>
                            <div key={sectionIndex}>
                                {
                                section.questions.map((quest, questIndex) => {
                                    const answer = quest.answer.find(x =>x.answered === 'true');
                                    const message = answer && (answer.score === 'T1' || answer.score === 'T2' || answer.score === 'T3')? "-" + answer.scoreMessage: "";
                                    
                                    if(!answer) return null;

                                    return (
                                    <div key={questIndex} style={styled.result}>
                                        <p>Question: {quest.question}</p>
                                        <p>Answer: {answer.text}</p>
                                        <p>MESSAGE: {message}</p>
                                    </div>
                                    )
                                })
                                } 
                            </div>     
                            
                            </div>  
                        ) 
                        })}
                    </div>
            </div>
        </Fragment>
        </ScrollToTop>
    )    
}

export default DownloadReportCTA;